import * as Form from "@radix-ui/react-form";
import { FaSpinner } from "react-icons/fa";
import styled from "styled-components";

export const Loader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: ${({ theme }) => theme.colors.primary};
  z-index: 1000;
  background: ${({ theme }) => theme.branding.backgroundColor};
  opacity: 0.5;
`;

export const Container = styled.div`
  flex: 1;
  /* overflow-y: auto; */

  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: 1rem;

  /* @media (max-width: 480px) {
    padding-top: 350px;
    padding-bottom: 300px;
  } */
`;

export const Header = styled.h2`
  text-align: center;
  font-size: 32px;
  margin: 0.5rem;

  color: ${({ theme }) => theme.colors.primary};
`;

export const HeaderTitle = styled.h3`
  box-sizing: border-box;
  font-family: inherit;
  font-weight: 800;
  line-height: 36px;
  margin-top: 20px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0px 0px 28px;

  /* font-size: 32px;
  margin-bottom: 1.5rem;*/
`;

export const SubTitle = styled.h3`
  color: ${({ theme }) => theme.colors.primary};
  flex: 1;
  margin: 0;
`;

export const SectionWrapper = styled.div`
  background-color: ${({ theme }) => theme.branding.color};
  width: 100%;
  max-width: ${(props) => (props.width ? `${props.width}` : "100%")};
  box-sizing: border-box;
  box-shadow: rgba(32, 41, 79, 0.26) 0px 0px 24px 0px;
  border-radius: 8px;
  padding: 2rem;
  /* height: auto; */

  /* @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    height: auto;
  } */
`;

export const FormField = styled(Form.Field)`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
`;

export const Input = styled.input`
  display: block;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.branding.borderColor};
  border-radius: 0.25rem;

  padding-right: 2.5rem;

  &:focus {
    border-color: ${({ theme }) => theme.branding.backgroundColor};
    outline: none;
  }
`;

export const Button = styled.button`
  padding: 0.75rem;
  font-size: 18px;
  font-weight: bold;
  line-height: 23px;
  padding: 15px 45px;
  border-radius: 28px;
  background: ${({ theme }) => theme.button.background};
  color: ${({ theme }) => theme.button.color};
  border: none;
  font-size: 1rem;
  cursor: pointer;
  /* margin-top: 1rem; */
  width: 100%;

  &:hover {
    background: ${({ theme }) => theme.button.hover};
  }

  &:disabled {
    background: ${({ theme }) => theme.button.disabled};
    cursor: not-allowed;
  }
`;

export const PaginationButton = styled.button`
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:disabled {
    background-color: ${({ theme }) => theme.button.disabled};
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.button.hover};
  }
`;

export const FieldMessage = styled.div`
  color: ${(props) => props.theme.colors[props.type]};
  margin-top: 0.5rem;
  font-size: 0.875rem;
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const FieldButtonIcon = styled.button`
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
`;

export const SpinnerIcon = styled(FaSpinner)`
  margin-left: 0.5rem;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const NavigationButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;

export const HelpText = styled.span`
  font-size: 0.875rem;
  color: #000;
  margin-top: 5px;
  /* color: ${({ theme }) => theme.colors.helpText}; */
`;

export const DisplaySection = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  /* justify-content: space-between; */

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
`;

export const Section = styled.div`
  flex: 1;
  /* height: 100%; */

  @media screen and (min-width: 768px) {
    margin-right: 20px;
    margin-bottom: 0;
  }
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  @media (max-width: 900px) {
    gap: 10px; /* Reduce gap for tablet screens */
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    gap: 0px;
  }
`;

export const Content = styled.div`
  padding: 1rem;
  max-width: 100%;

  @media (max-width: 768px) {
    padding: 15px;
  }

  @media (max-width: 480px) {
    padding: 10px;
  }
`;
